<template>
  <div id="app">
    <Head></Head>
    <div class="banner">
      <img
        :src="this.$path + '/assets/images/portable/outdoor_power.jpeg'"
        :alt="$t('langs.aolei')"
      />
    </div>
    <!--aray power-->
    <div class="portable_center" style="margin-top: 20px">
      <div class="portable_context">
        <img
          class="pullpower"
          :src="this.$path + '/assets/images/portable/araypower.png'"
          :alt="$t('langs.aolei')"
        />
        <span>
          <div class="title_portable_context">
            <div class="title_portable_name">
              {{ $t("langs.portablepower.powertitle") }}
            </div>
          </div>
          <div class="portable_botton_context">
            <div class="portable_span_line">
              <div class="botton_portable_circle"></div>
              <div class="info_portable_text">
                {{ $t("langs.portablepower.subtitle1") }}
              </div>
            </div>
            <div class="portable_span_line">
              <div class="botton_portable_circle"></div>
              <div class="info_portable_text">
                {{ $t("langs.portablepower.subtitle2") }}
              </div>
            </div>
            <div class="portable_span_line">
              <div class="botton_portable_circle"></div>
              <div class="info_portable_text">
                {{ $t("langs.portablepower.subtitle3") }}
              </div>
            </div>
            <div class="portable_span_line">
              <div class="botton_portable_circle"></div>
              <div class="info_portable_text">
                {{ $t("langs.portablepower.subtitle4") }}
              </div>
            </div>
          </div>
        </span>
      </div>
    </div>
    <!--拉杆式电源-->
    <div class="portable_center" style="margin-top: 20px">
      <div class="portable_context">
        <span>
          <div class="title_portable_context">
            <div class="title_portable_name">
              {{ $t("langs.portablepower.pullpowertitle") }}
            </div>
          </div>
          <div class="portable_botton_context">
            <div class="portable_span_line">
              <div class="botton_portable_circle"></div>
              <div class="info_portable_text">
                {{ $t("langs.portablepower.pullsubtitle1") }}
              </div>
            </div>
            <div class="portable_span_line">
              <div class="botton_portable_circle"></div>
              <div class="info_portable_text">
                {{ $t("langs.portablepower.pullsubtitle2") }}
              </div>
            </div>
            <div class="portable_span_line">
              <div class="botton_portable_circle"></div>
              <div class="info_portable_text">
                {{ $t("langs.portablepower.pullsubtitle3") }}
              </div>
            </div>
            <div class="portable_span_line">
              <div class="botton_portable_circle"></div>
              <div class="info_portable_text">
                {{ $t("langs.portablepower.pullsubtitle4") }}
              </div>
            </div>
          </div>
        </span>
        <img
          :src="this.$path + '/assets/images/portable/pullpower.jpg'"
          :alt="$t('langs.aolei')"
        />
      </div>
    </div>
    <!--拉杆箱储能电源-->
    <div
      class="box_center_pd"
      :style="[
        this.$store.state.currentLang === 'zh'
          ? { margin: '200px 0 0 0' }
          : { margin: '300px 0 0 0' },
      ]"
    >
      <span class="portable_text_pd">{{
        $t("langs.portablepower.pullstoragepower")
      }}</span>
    </div>
    <div class="row_line">
      <span class="td_line"></span>
    </div>
    <div class="portable_mian_center" style="margin-top: 0px !important">
      <div class="power_images">
        <img
          :src="this.$path + '/assets/images/portable/pull0.jpeg'"
          :alt="$t('langs.aolei')"
        />
        <img
          :src="this.$path + '/assets/images/portable/pull1.jpg'"
          :alt="$t('langs.aolei')"
        />
        <img
          :src="this.$path + '/assets/images/portable/pull2.jpg'"
          :alt="$t('langs.aolei')"
        />
        <img
          :src="this.$path + '/assets/images/portable/pull3.jpg'"
          :alt="$t('langs.aolei')"
        />
      </div>
    </div>
    <div class="portable_mian_center">
      <span class="word_center">{{ $t("langs.portablepower.pullstoragedesc") }}</span>
    </div>

    <!--产品特性-->
    <div class="box_center_pd">
      <span class="portable_text_pd">{{ $t("langs.portablepower.productfeature") }}</span>
    </div>
    <div class="row_line">
      <span class="td_line" style="margin-bottom: 20px"></span>
    </div>
    <div class="portable_center_memo">
      <div class="layer_center flex-col_center">
        <div class="mode_block_center flex-col_center">
          <img
            referrerpolicy="no-referrer"
            :src="this.$path + '/assets/images/portable/safe_icon.png'"
            :alt="$t('langs.aolei')"
          />
          <span class="info_title_center">{{
            $t("langs.portablepower.safefeaturetitle")
          }}</span>
          <!-- <span class="info_memo_center">{{
            $t("langs.portablepower.safesubtitle1")
          }}</span>
          <span class="info_memo_center">{{
            $t("langs.portablepower.safesubtitle2")
          }}</span>
          <span class="info_memo_center">{{
            $t("langs.portablepower.safesubtitle3")
          }}</span> -->
        </div>
      </div>
      <div class="layer_center flex-col_center">
        <div class="mode_block_center flex-col_center">
          <img
            referrerpolicy="no-referrer"
            :src="this.$path + '/assets/images/portable/power_icon.png'"
            :alt="$t('langs.aolei')"
          />
          <span class="info_title_center">{{
            $t("langs.portablepower.powerfeaturetitle")
          }}</span>
          <!-- <span class="info_memo_center">{{
            $t("langs.portablepower.powersubtitle1")
          }}</span>
          <span class="info_memo_center">{{
            $t("langs.portablepower.powersubtitle2")
          }}</span>
          <span class="info_memo_center">{{
            $t("langs.portablepower.powersubtitle3")
          }}</span> -->
        </div>
      </div>
    </div>
    <div class="portable_center_memo">
      <div class="layer_center flex-col_center">
        <img class="show_power" :src="this.$path + '/assets/images/portable/power.png'" />
      </div>
    </div>
    <div class="portable_center_memo">
      <div class="layer_center flex-col_center">
        <div class="mode_block_center flex-col_center">
          <img
            referrerpolicy="no-referrer"
            :src="this.$path + '/assets/images/portable/AI_icon.png'"
          />
          <span class="info_title_center">{{
            $t("langs.portablepower.aifeaturetitle")
          }}</span>
          <!-- <span class="info_memo_center">{{
            $t("langs.portablepower.aisubtitle1")
          }}</span>
          <span class="info_memo_center">{{
            $t("langs.portablepower.aisubtitle2")
          }}</span> -->
        </div>
      </div>
      <div class="layer_center flex-col_center">
        <div class="mode_block_center flex-col_center">
          <img
            referrerpolicy="no-referrer"
            :src="this.$path + '/assets/images/portable/ergonomic_icon.png'"
          />
          <span class="info_title_center">{{
            $t("langs.portablepower.lightweighttitle")
          }}</span>
          <!-- <span class="info_memo_center">{{
            $t("langs.portablepower.lightweightsubtitle1")
          }}</span>
          <span class="info_memo_center">{{
            $t("langs.portablepower.lightweightsubtitle2")
          }}</span> -->
        </div>
      </div>
    </div>

    <!--产品性能参数-->
    <div class="box_center_pd">
      <span class="portable_text_pd">{{ $t("langs.portablepower.productparams") }}</span>
      <div class="row_line"><span class="td_line"></span></div>
      <img
        v-if="this.$store.state.currentLang === 'zh'"
        :src="this.$path + '/assets/images/portable/params.png'"
        :alt="$t('langs.homepower')"
      />
      <img
        v-if="this.$store.state.currentLang === 'en'"
        :src="this.$path + '/assets/images/portable/params_en.png'"
        :alt="$t('langs.homepower')"
      />
    </div>
    <Footer></Footer>
    <Hover></Hover>
  </div>
</template>

<script>
import Head from "../components/head/head.vue";
import Footer from "../components/footer/footer.vue";
import Hover from "../components/hover";

export default {
  name: "centercloud",
  components: { Head, Footer, Hover },
};
</script>

<style scoped>
@import "../assets/css/center.css";

.portable_center {
  width: auto;
  display: flex;
  padding: 10px 10%;
  justify-items: center;
  justify-content: center;
  font-size: 16px;
  color: #666666;
  line-height: 24px;
}

.portable_botton_context {
  display: block;
  width: 100%;
  text-align: left;
  height: 230px;
  padding-left: 10%;
}

.portable_span_line {
  width: 90%;
  height: 28px;
  margin: 10px 5px;
  font-size: 18px;
  font-weight: 400;
  display: inline-block;
  text-align: left;
}

.botton_portable_circle {
  width: 8px !important;
  height: 8px !important;
  display: block;
  background-color: #00d265;
  border-radius: 50%;
  margin-top: 10px;
  margin-right: 15px;
  float: left;
}

.info_portable_text {
  width: 90%;
  overflow-wrap: break-word;
  color: #666666;
  display: inline-block;
  white-space: initial;
}

.word_center {
  width: 1024px;
  height: auto;
  display: block;
  overflow-wrap: break-word;
  color: rgba(102, 102, 102, 1);
  font-size: 18px;
  line-height: 25px;
  letter-spacing: 1px;
  text-align: left;
  margin-top: 10px;
}

.main_block_div {
  display: inline-block;
  margin: 0px 10px;
  padding: 5px 15px;
  overflow-wrap: break-word;
  word-break: normal;
  width: 486px;
  height: auto;
}

.main_block_img {
  width: 480px;
  height: 450px;
  display: inline-block;
  margin: 0px 10px;
  padding: 0px 15px;
  border: 0px;
}

.portable_context {
  width: 1026px;
  flex-direction: row;
  align-items: center;
  display: contents;
}
.portable_context span {
  width: 50%;
  height: 300px;
  display: inline-block;
  margin-left: 1px;
}
.portable_context img {
  width: 521px;
  height: 300px;
  display: inline-block;
  border: 0px;
}

.title_portable_context {
  height: 60px;
  margin: 10px 0px;
}

.title_portable_name {
  height: 48px;
  font-size: 40px;
  font-weight: bold;
  /* width: 70%; */
  display: inline-block;
  color: darkturquoise;
  line-height: 48px;
  text-align: left;
  padding-left: 10%;
}

.green {
  background-color: #00d265;
  height: 16px;
  width: 16px;
  display: inline-block;
}
.gray {
  background-color: #d8d8d8;
  height: 16px;
  width: 16px;
  display: inline-block;
  margin-left: 10px;
}

.flex-col_center {
  display: flex;
  flex-direction: column;
}

.portable_mian_center {
  width: auto;
  display: flex;
  margin-top: 20px;
  text-align: center;
  justify-content: center;
}

.portable_center_memo {
  width: auto;
  display: flex;
  margin-top: 20px;
  padding: 0px 15%;
}

.layer_center {
  z-index: 115;
  height: 170px;
  background-color: rgba(216, 216, 216, 0);
  width: 340px;
  justify-content: center;
  align-items: center;
  flex: 1;
}

.info_title_center {
  z-index: 121;
  width: auto;
  height: 25px;
  display: block;
  overflow-wrap: break-word;
  color: darkturquoise;
  font-size: 18px;
  white-space: nowrap;
  line-height: 25px;
  text-align: center;
  margin-top: 12px;
}

.info_memo_center {
  z-index: 123;
  width: auto;
  height: 20px;
  display: block;
  overflow-wrap: break-word;
  color: rgba(170, 170, 170, 1);
  font-size: 14px;
  white-space: nowrap;
  word-space: 1px;
  line-height: 20px;
  text-align: left;
  margin-top: 4px;
  padding-left: 28%;
}

.mode_block_center {
  width: 100%;
  align-items: center;
  justify-items: center;
  text-align: center;
  display: block;
}

.mode_block_center img {
  z-index: 116;
  width: auto;
  height: 30px;
}
.show_power {
  width: 300px;
  height: 300px;
  margin-top: 32px;
}
.power_images {
  display: flex;
  margin-top:30px;
}
.power_images img {
  flex: 1;
  width: 280px;
  height: 280px;
}
.pullpower {
  width: 500px !important;
  height: 450px !important;
  display: inline-block;
  border: 0px;
}
.portable_text_pd {
  font-size: 24px;
  color: darkturquoise;
  height: 48px;
  font-size: 40px;
  font-weight: bold;
  display: inline-block;
  color: darkturquoise;
  line-height: 48px;
}
</style>



// WEBPACK FOOTER //
// src/view/outdoorpower.vue